module.exports = __webpack_public_path__ + "img/Material_Upload.cf417850.svg";